import { API } from "../comunApi"
import { endpoints } from "../endpoints"

export const viewContactPresentationApi = {
    //Obtener el token
    goToAccessPresentationOfAContact: async (idContactPresentacion, params) => {
        return await API.post(
            endpoints.ACCESS_TO_PRESENTATION_OF_A_CONTACT(idContactPresentacion),
            params
        )
    },
}